import { defineStore } from "pinia";
import { apiCall } from "../../utils/api";

export const useCardTagStore = defineStore("cardTag", {
  state: () => ({
    tags: [],
  }),
  getters: {
    tagObj: (state) => {
      const rtn = {};
      state.tags.forEach((item) => {
        rtn[item.id] = item.name;
      });
      return rtn;
    },
  },
  actions: {
    async getAll(force = false) {
      if (force || this.tags.length === 0) {
        const response = await apiCall("card.getTags", {});
        if (!response) {
          return false;
        }
        this.tags = response;
      }

      return true;
    },
    async add(params = {}) {
      const response = await apiCall("card.addTag", params);
      if (!response) {
        return false;
      }
      await this.getAll(true);
      return true;
    },
    async edit(id, params = {}) {
      params.id = id;
      const response = await apiCall("card.modifyTag", params);
      if (!response) {
        return false;
      }
      await this.getAll(true);
      return true;
    },
  },
});
